var _learnq = window._learnq || [];
var swiperSection			= {};
var slfCounter				= {};
var previousScrollTop 		= 0;
var updateLineitem			= {};
var loadedAsyncScripts 		= 0;
var loadAsyncScripts 		= [];
var CONFETTI, SIZE = {}, module = {};

//loadAsyncScripts.push("https://app.usercentrics.eu/latest/main.js");
if(((__st.pageurl).includes('fwf-share') || (__st.pageurl).includes('fwf-main')) && 1 == 2){
  loadAsyncScripts.push("https://theapicompany.com/geolocationAPI.js?id=morenutrition");
  loadAsyncScripts.push("https://theapicompany.com/deviceAPI.js?id=deviceAPI-jild79jr0e");
}
if(!showRendering){ loadAsyncScripts.push("\/\/morenutrition.de\/cdn\/shop\/t\/247\/assets\/dgs-functions.js?v=52387594593866160871697730562"); }
if(!showRendering && ngtDigest == 1){ loadAsyncScripts.push("\/\/morenutrition.de\/cdn\/shop\/t\/247\/assets\/dgs-digest.js?v=14906821540406799071697464059"); }
if(!showRendering){ loadAsyncScripts.push("\/\/morenutrition.de\/cdn\/shop\/t\/247\/assets\/dgs-ajaxcart.js?v=56570408886841751821697464059"); }
if(!showRendering && loadLottie){ loadAsyncScripts.push("\/\/morenutrition.de\/cdn\/shop\/t\/247\/assets\/lottie-player.js?v=162478467786061555841697464059"); }
if(!showRendering && assetFlip){ loadAsyncScripts.push("\/\/morenutrition.de\/cdn\/shop\/t\/247\/assets\/flip.min.js?v=120002213966204382041697464059"); }
if(!showRendering && cartConfetti){ loadAsyncScripts.push("\/\/morenutrition.de\/cdn\/shop\/t\/247\/assets\/confetti.min.js?v=19988262479873970131697464059"); }
if(!showRendering && assetSwiper){ loadAsyncScripts.push("\/\/morenutrition.de\/cdn\/shop\/t\/247\/assets\/swiper-bundle.min.js?v=179144147937258820731697464059"); }
if(!showRendering){ loadAsyncScripts.push("\/\/morenutrition.de\/cdn\/shop\/t\/247\/assets\/html2canvas.min.js?v=184069144830478313421697464059"); }
const lang_cartCloseMsg		= "Kauf momentan nicht möglich!";
function noUnload(){ return "Bitte warte den Countdown ab ohne die Seite zu aktualisieren."; }
function noUnload_set(){ window.onbeforeunload = noUnload; }
function noUnload_none(){ window.onbeforeunload = ''; }
var vis = (function(){
  var stateKey, eventKey, keys = {
    hidden: "visibilitychange",
    webkitHidden: "webkitvisibilitychange",
    mozHidden: "mozvisibilitychange",
    msHidden: "msvisibilitychange"
  };
  for (stateKey in keys) {
    if (stateKey in document) {
      eventKey = keys[stateKey];
      break;
    }
  }
  return function(c) {
    if (c) document.addEventListener(eventKey, c);
    return !document[stateKey];
  }
})();

function dgsSession(obj = {}, type = 'open', prop = '', cont){
  if(type == "open"){
    var dgsSession 		= sessionStorage.getItem('dgs_session');
    dgsSession 			= (dgsSession === null) ? "" : dgsSession;
    dgsSession 			= (dgsSession != "") ? JSON.parse(dgsSession) : {};
    return dgsSession;
  }else if(type == "read"){
    return obj['__'+prop] = ('__'+prop in obj) ? obj['__'+prop] : {};
  }else if(type == "push"){
    obj['__'+prop] = cont;
    return obj;
  }else if(type == "save"){ 
    sessionStorage.setItem('dgs_session',JSON.stringify(obj));
  }
}
function dgsLocal(obj = {}, type = 'open', prop = '', cont){
  if(type == "open"){
    var dgsLocal 		= localStorage.getItem('dgs_local');
    dgsLocal 			= (dgsLocal === null) ? "" : dgsLocal;
    dgsLocal 			= (dgsLocal != "") ? JSON.parse(dgsLocal) : {};
    return dgsLocal;
  }else if(type == "read"){
    return obj['__'+prop] = ('__'+prop in obj) ? obj['__'+prop] : {};
  }else if(type == "push"){
    obj['__'+prop] = cont;
    return obj;
  }else if(type == "save"){ 
    localStorage.setItem('dgs_local',JSON.stringify(obj));
  }
}
function checkDiscountCode(code){
  var discounts 	= atob(allowedCodes);
  if(discounts){
    var discountsArr	= discounts.split("|");
    if(specialEvent[currentSpecialEvent] && closePage == 0){ 
      var eventDiscounts 		= atob(eventCodes);
      var eventDiscountsArr	= eventDiscounts.split("|");
      var discountsArr		= [...new Set([...discountsArr ,...eventDiscountsArr])];
    }
    var code 		= (typeof code !== "undefined") ? code : getCookie("discount_code");
    code 			= (code) ? code.toUpperCase() : false;
    if(code && maskingCodes){ 
      var coverDiscountCodes = swapKeysAndValues(maskingDiscountCodes);
      if(!! coverDiscountCodes[code]){
        code = coverDiscountCodes[code];
      }
    }
    code = (code && code != "none") ? code : false;
    if(code){
      var last2code = code.slice(-2);
      if(cartKill10 && last2code == "10"){ code = code.replace('10',''); }
    }
    if(code && ($.inArray(code, discountsArr) >= 0 || code.includes("M2W-"))){ return code; }
    //if(discountsArr.includes(code)){ return code; }
    else{ return false; }
  }else{ return false; }
}
function decodeLiquidData(encoded){
  ////console.log(encoded);
  if(typeof encoded !== "undefined"){
    var encoded	= parseFloat(encoded);
    var decoder1 	= parseInt(new Date().getFullYear());
    var decoder2 	= parseInt(new Date().getMonth()) + 1;
    var decoded 	= Math.round((encoded / decoder2) * decoder1);
    var decoded 	= btoa(decoded+"|"+decoded+"|"+decoded);
    return decoded;
  }else{ return encoded; }
}
function encodeLiquidData(decoded){
  ////console.log(decoded);
  if(typeof decoded !== "undefined"){
    var decoded	= atob(decoded);
    var decoded	= decoded.split("|");
    var decoded	= parseFloat(decoded[0]);
    var encoder1 	= parseInt(new Date().getFullYear());
    var encoder2 	= parseInt(new Date().getMonth()) + 1;
    return Math.round((decoded / encoder1) * encoder2);
  }else{ return decoded; }
}
function getCurrentRedirect(){
  var currentURL	 	= window.location.href;
  var uselessURL	  	= window.location.protocol + '//' + window.location.hostname;
  var currentRedirect 	= currentURL.replace(uselessURL,"");
  return currentRedirect;
}

function scroll2Element(elm,header = 1){
  var $elm = elm;
  var paddingTop		= Math.abs(parseInt(($("main").find("section[dgs-spacer]").first().css("padding-top")).replace("px","")));
  if(header == 1 && $("header").length){
    var headerTop			= Math.abs(parseInt(($("header").css("top")).replace("px","")));
    var headerHeight		= Math.abs(parseInt($("header").innerHeight()));
  }else{ var headerTop = 0, headerHeight = 0; }
  var distanceTop		= ($(window).scrollTop() >= headerTop) ? headerHeight - headerTop : headerHeight;
  $('html, body').animate({ scrollTop: ($elm.offset().top - distanceTop - paddingTop) }, 750);
}
function dgsChangeImage(event,container,slider,slide,slide_id,action){
  var breakpoint 	= parseInt(768);
  var $container	= $("div[data-container='"+container+"']");
  var $slider		= $container.find("*[data-type='"+slider+"']");
  var $slide		= $container.find("*[data-type='"+slide+"'][data-slide='"+slide_id+"']");
  var slide_pre		= $slide.attr("data-pre");
  var slide_img		= $slide.attr("data-img");
  if(event != "hover" || (event == "hover" && $(window).width() >= breakpoint)){
    if(action == "over"){
      $slider.css("backgroundImage","url('"+slide_pre+"')");
      $('<img/>').attr('src',slide_img).on('load', function() {
        $(this).remove();
        $slider.css("backgroundImage","url('"+slide_img+"')");
      });
    }else{
      $slider.css("backgroundImage","url()");
    }
  }
}


function discountItemSelector(event,pid,vid,tags){
  ////console.log("TEST",cartJSON.items);
  var checkups = 0;
  if((event.product_ids).length === 0 && (event.variant_ids).length === 0 && (event.product_tags).length === 0){
    return true;
  }
  if((event.product_ids).length === 0 || ((event.product_ids).length > 0 && (event.product_ids).includes(pid.toString()))){
    checkups++; ////console.log("product_ids",event.product_ids); 
  }
  if((event.variant_ids).length === 0 || ((event.variant_ids).length > 0 && (event.variant_ids).includes(vid.toString()))){
    checkups++; ////console.log("variant_ids",event.variant_ids); 
  }
  if((event.product_tags).length === 0 || ((event.product_tags).length > 0 && anyOfArrays(event.product_tags,tags))){
    checkups++; ////console.log("product_tags",event.product_tags);  
  }
  ////console.log("checkups",checkups);
  return (checkups == 3) ? true : false;
}
function discountCartSelector(event,ctags,code){
  if(event.allowed_codes.length > 0 && !(event.allowed_codes).includes(code)){
    return false;         
  }
  if(event.customer_tags.length > 0 && !anyOfArrays(event.customer_tags,ctags)){
    return false;     
  }
  return true;
}
function generateActivateDiscount(type = 'default', price = false,disc = false){
  var source 		= document.getElementById("dgs-tpl-discount-activate-modal").innerHTML; 
  var template 		= Handlebars.compile(source);
  var codeFlag      = ("<discounttag><disc>[CODE]</disc></discounttag>").replace("[CODE]",launchObjCode);
  if(type == 'product'){
    var text = cartDiscountText2;
    text = text.replace("[CODE]",codeFlag);
    text = text.replace("[PRICE]","<b>"+formatNumber(price/100, 2, ",", ".")+" €*</b>");
    text = text.replace("[DISC]","<b sale>"+formatNumber(disc/100, 2, ",", ".")+" €*</b>");  
  }else{
    sessionStorage.removeItem("__t_bms_discount-activate");
    var text = cartDiscountText1;
    text = text.replace("[CODE]",codeFlag);
  }
  var context 		= {'code':launchObjCode,'text':text};
  var $render 	= template(context);
  $render 		= $render.replaceAll(/\n|\r/g, "").replaceAll(/\s{2,}/g, ' ');
  openModal('Handlebars',$render,"discount-activate",0,0);
}
function calculateDiscounts(items = false){
  var checkCode = (!getCookie("discount_code") && discountWithoutCode) ? "none" : checkDiscountCode();
  var eventIDs = (transferedEvents) ? transferedEvents.map(function(element){ return `${element.id}`; }) : [];
  var isTiered = (eventIDs.length && (eventIDs.includes('tiered') || eventIDs.includes('staffel'))) ? true : false; 
  if(checkCode && transferedEvents && priceWithCode){
    if($(".dgs-details-offer-staffeln").length && isTiered){
      $(".dgs-details-offer-staffeln").removeAttr("dgs-hidden-important");
      if($(".dgs-product-qtyselect").length){
        $(".dgs-product-qtyselect").removeAttr("dgs-hidden-important");
      }
    }
    if(checkCode == "none"){
      var $launchFlag = $("discounttag[launch]");
      $launchFlag.attr("disabled","");
      if($launchFlag.length && discountActivation != "none"){
        $launchFlag.attr("clickable","").attr("data-tooltip",cartDiscountTooltip);
        $launchFlag.on("click",function(){
          if(discountActivation == "direct"){ activateDiscountCode(); }
          else if(discountActivation == "modal"){ generateActivateDiscount(); }
        });
      }
    }else{ $("discounttag[launch]").removeAttr("disabled"); }
    var $items 		= $("body").find("*[data-type='discount-price']");
    $items.each(function(){
      var $container = $(this).closest("[data-container]");
      var item_pid = parseInt($(this).attr("item-pid"));
      item_pid = (typeof item_pid !== "undefined" && item_pid != "") ? item_pid : false;
      var item_vid = parseInt($(this).attr("item-vid"));
      item_vid = (typeof item_vid !== "undefined" && item_vid != "") ? item_vid : false;
      var item_tags = $(this).attr("item-tags");    
      item_tags = (typeof item_tags !== "undefined" && item_tags != "") ? item_tags.split(",") : [];
      var item_price = parseInt($(this).attr("item-price"));
      item_price = (typeof item_price !== "undefined" && item_price != "") ? item_price : false;
      var item_type = $(this).attr("item-type");
      item_type = (typeof item_type !== "undefined" && item_type != "") ? item_type : "default";
      $(this).attr("item-status","crawled");
      //console.log("ITEM",item_pid,item_vid,item_tags,item_price,item_type);
      if(item_pid && item_vid && item_tags && item_price){
        ////console.log("ITEM",item_pid,item_vid,item_tags,item_price);
        var discountItem = calculateDiscountsItem(item_pid,item_vid,item_tags,item_price,1,item_type);
        ////console.log("discountItem",discountItem);
        if(discountItem.length){
          var discountTextSplit 	= discountItem[2].split(" ");
          if(discountTextSplit[1] !== undefined){
            var discountCodeLetter    = (item_type == "modal" || item_type == "details") ? 6 : 4;
            var discountCodeText 		= (discountTextSplit[1].length <= discountCodeLetter) ? " "+discountTextSplit[1] : "";
            var discountCodeCheck		= (discountTextSplit[1].length <= discountCodeLetter) ? "code" : "";
          }else{ var discountCodeText = "", discountCodeCheck = ""; }
          var discountTag 			= "<discounttag "+discountCodeCheck+"><disc>"+discountTextSplit[0]+"</disc>"+discountCodeText+"</discounttag>";
          if(item_type == "modal"){
            var replacer = "<discountbadge><name>"+discountTag+"</name><price>"+discountItem[1]+"</price></discountbadge>";
            $container.find(".dgs-modal-price").attr("discounted","").find("*[data-type='discount-price']").html(replacer);
            if($(".dgs-modal-staffeln").length && isTiered){
              $(".dgs-modal-staffeln").removeAttr("dgs-hidden-important");
              if($(".dgs-modal-product-qtyselect").length){
                $(".dgs-modal-product-qtyselect").removeAttr("dgs-hidden-important");
              }
            }
          }else{
            $(this).find("*[data-type='product-price-withcode']").text(discountItem[1]);
            $(this).find(".dgs-block-product_withcode-text").html(discountTag);
            $(this).find("*[data-type='discount-code']").text(checkCode);
            $container.find(".dgs-block-product_price").attr("data-withcode",1);
            $container.find(".dgs-block-product_pricebox-price").attr("discounted","");            
            var $portionprice = $container.find("*[data-type='portionprice']");
            ////console.log($portionprice.length);
            if($portionprice.length){
              var variant_portions = parseInt($portionprice.attr("portions"));
              ////console.log("variant_portions",variant_portions);
              if(variant_portions){
                var portionprice	= parseFloat(discountItem[0]) / parseInt(variant_portions);
                var portionprice 	= formatNumber((portionprice/100), 2, ",", ".")+"  €*";
                ////console.log("portionprice",portionprice);
                $container.find("*[data-type='portionprice']").attr("discounted","");
                $container.find("*[data-type='portionprice']").find("s").text(portionprice);
              }
            }
          }
          if(checkCode == "none"){
            $container.find("discounttag:not([tier])").attr("disabled","");
            if(item_type == "details" || item_type == "modal"){ 
              $container.find("form").attr("nodiscount","");
              if(discountActivation != "none"){
                $container.find("discounttag:not([tier])").attr("clickable","").attr("data-tooltip",cartDiscountTooltip);
                $container.find("discounttag:not([tier])").on("click",function(){
                  $(this).closest("[data-type='discount-price']").attr("loader","");
                  if(discountActivation == "direct"){ activateDiscountCode(); }
                  else if(discountActivation == "modal"){ generateActivateDiscount('product', item_price, discountItem[0]); }
                });
              }
            }
          }else{
            $container.find("form").removeAttr("nodiscount");
          }
          $(this).attr("item-status","discounted");
          $(this).css("display","flex");
        }else{ clearDiscountsItem($(this)); }
      }
    });
  }else{
    var $items 		= $("body").find("*[data-type='discount-price'][item-status='discounted']");
    $items.each(function(){ clearDiscountsItem($(this)); });
  }
}
function calculateDiscountsItem(pid,vid,tags,price,qty = 1,type = 'details'){
  var discountItem	= [];
  ////console.log("transferedEvents",transferedEvents);
  //console.log("item_type",type);
  var checkCode 		= checkDiscountCode();
  if(!getCookie("discount_code") && discountWithoutCode) {
    //console.log("calculateDiscountsItem",launchObjProductsArr,pid.toString());
    if(launchObjCollection == currentCollection || 
    (launchObjProductsArr.includes(pid.toString()) && (discountEverywhere || pageType == "product" || type == "modal"))){     
      checkCode = "none";
    }
  }
  ////console.log("checkCode",checkCode);
  if(checkCode && transferedEvents && priceWithCode){
    var $events = transferedEvents;
    var discounted = false;
    $events.forEach(function(event, index) {
      ////console.log("event-id",event.id,discounted);
      if(!discounted){
        var ctags			= (customerTags) ? customerTags : [];
        ////console.log("CustomerTags",ctags,event.customer_tags);
        var cartSelector 	= discountCartSelector(event,ctags,checkCode);
        var itemSelector 	= discountItemSelector(event,pid,vid,tags);
        var discountable	= tags.includes("nodiscount") ? false : true;
        //if(event.id == "tiered"){ //console.log("selector",pid,vid,tags,cartSelector,itemSelector,discountable); }
        if(cartSelector && itemSelector && discountable){
          discounted = true;
          ////console.log("DISCOUNT",event.discount_type,event.discount_value,event.discount_text,price);
          var newPrice			= calculateDiscountsItemPrice(event,price,qty,checkCode);
          discountItem.push(newPrice);
          //var newPriceDecimal 	= parseInt(newPrice) / 100;
          var newPriceDecimal 	= Number(Math.round((Math.round(newPrice) / 100) + "e3") + "e-3").toFixed(2);
          var newPriceFormated 	= formatNumber(newPriceDecimal, 2, ",", ".")+" €*";
          //var newPriceFormated 	= newPriceDecimal.replace(/(\.0*|(?<=(\..*))0*)$/, '')+" €*";
          discountItem.push(newPriceFormated);
          var discTxt = event.discount_text;
          var isTiered = (event.id == 'tiered' || event.id == 'staffel') ? true : false; 
          if(checkCode == "none"){
            discTxt = (isTiered && event.hasOwnProperty('stages')) ? event.stages[0].message : discTxt;
          }else{
            if(isTiered){
              discTxt = (isTiered && event.hasOwnProperty('stages')) ? event.stages[0].message : discTxt;
            }else{
              discTxt = (isTiered && event.hasOwnProperty('current')) ? event.current[1] : discTxt;
            }
          }
          ////console.log("event-id",event.id,discTxt);
          var discountText		= (discTxt).replace(".",",").replace("+"," ");
          var codeName          = (checkCode == "none") ? launchObjCode : checkCode;
          var newPriceText		= (discountText).replace("$codename",codeName);
          discountItem.push(newPriceText);
        }
      }
    });
  }
  ////console.log("discountItem",discountItem);
  return discountItem;
}
function calculateDiscountsItemPrice(event,price,qty,code = false){
  var isTiered = (event.id == 'tiered' || event.id == 'staffel') ? true : false;
  var discVal = event.discount_value;
  if(code == "none"){
    discVal = (isTiered && event.hasOwnProperty('stages')) ? parseInt(event.stages[0].discount) : discVal;
  }else{
    if(isTiered){
      discVal = (isTiered && event.hasOwnProperty('stages')) ? parseInt(event.stages[0].discount) : discVal;
    }else{
      discVal = (isTiered && event.hasOwnProperty('current')) ? event.current[0] : discVal;
    }
  }
  //console.log(event,price,qty,code,discVal);
  if(event.discount_type == "fixed"){
    var discAmount 	= parseFloat(discVal * 100);
    var newPrice	= parseFloat(price) - discAmount;
  }else if(event.discount_type == "percentage"){
    var discAmount 	= (Math.round(parseFloat(price)) / 100) * parseFloat(discVal);
    var newPrice	= parseFloat(price) - discAmount;
  }else{
    var newPrice	= price;
  }
  return parseInt(newPrice * qty);
}
function activateDiscountCode(){
  $("div[loader]").attr("loadercover","");
  var modal = parseInt($(".dgs-modal").attr("data-open"));
  var getBackModal = sessionStorage.getItem("__t_bms_discount-activate") ?? false;
  if(modal && getBackModal){ eval(getBackModal); }
  else if(modal){ closeModal(); }
  changeDiscountCode('cartbar',launchObjCode);
}
function clearDiscountsItem($item){
  var $container = $item.closest("[data-container]");
  $item.removeAttr("item-status").css("display","");
  $item.find("*[data-type='product-price-withcode']").empty();
  $item.find(".dgs-block-product_withcode-text").empty();
  $item.find("*[data-type='discount-code']").empty();
  $container.find(".dgs-block-product_price").attr("data-withcode",0);
  $container.find(".dgs-block-product_pricebox-price").removeAttr("discounted");
  $container.find("form").removeAttr("nodiscount");
}
function appendProductJSON(item){
  var itemPacks = item.packs;
  for (const [key, value] of Object.entries(itemPacks)) {
    var itemItems = value.items;
    for (const [key, value] of Object.entries(itemItems)) {
      if(value.product && allFreegifts){
        if(allFreegifts.hasOwnProperty(value.product)){
          value['json'] = allFreegifts[value.product];
        }
      }
    }
  }
  return item;
}
function availablePack(config,steps){
  var checkTag	= (config.hasOwnProperty('tag')) ? config.tag : false;
  var packs = steps.packs;
  var available	 	= [];
  for(p = 0; p < packs.length; p++){
    if(available.length == 0){
      var pack		= packs[p];
      var packItems = pack.items;
      var tempAvailable		= [];
      var packAvailable 	= true;
      var packTotalItems    = packItems.length;
      //console.log("packItems",packItems);
      packItems.forEach(function (item, index) {
        item.combine = steps.combine;
        if(item.hasOwnProperty('json')){
          var packItem = item.json;
          if(!packItem.hasOwnProperty('json')){
            if(packItem.available){
              if(!checkTag || (packItem.tags).includes(checkTag)){
                var avars = allFreegifts[packItem.handle] ?? [];
                var variants = (avars) ? (avars.variants).map(function(varitem){ if(varitem.available){ return parseInt(varitem.id); } }) : [];
                //console.log("varitems",avars,variants,item['variant'],anyOfArrays(item['variant'],variants));
                if(anyOfArrays(item['variant'],variants)){
                  tempAvailable.push(item);
                }
              }
            }else if(steps.flexible){ packTotalItems--; }
          }else if(steps.flexible){ packTotalItems--; }
        }else if(steps.flexible){ packTotalItems--; }
      });
      //console.log("compare",tempAvailable.length,packTotalItems);
      //console.log("settings",steps['combine'],steps.flexible);
      if(steps['combine'] && tempAvailable.length == packTotalItems){
        available = tempAvailable;
      }else if(!steps['combine'] && tempAvailable.length > 0){
        available = tempAvailable;
      }
    }
  }
  //console.log("availablePack",available);
  return available;
}
function getVariantJson(variants,variant,item){
  var cvar	= [false,false];
  //console.log("getVariantJson",variants,variant,item);
  if(variant && variant.length == 1){
    variants.forEach(function (item, index) {
      if(item.id == variant[0]){ cvar = [item,false]; }
    });
  }else if(variant && variant.length > 1){
    var avar = [];
    variant.reverse();
    variants.forEach(function (item, index) {
      if(variant.includes(item.id)){
        var n = variant.indexOf(item.id);
        var set_item = variants[index];
        variants[index] = variants[n];
        variants[n] = set_item;
      }
    });
    variants.forEach(function (item, index) {
      if(variant.includes(item.id) && item.available){ avar.push(item.id); }
    });
    //console.log("result",variants);
    variants.forEach(function (item, index) {
      if(avar.includes(item.id)){ cvar = [item,avar]; }
    });
  }
  var gvar = cvar[0];
  //console.log("gvar.available",gvar.available);
  //console.log("item.select",item.select);
  if(!gvar.available && item.select && !(variant.length > 1)){
    var availables = (variants) ? variants.map(function(variant){ if(variant.available){ return variant; } }) : false;
    if(availables){ 
      var filtered = availables.filter(function (el){ return el != null; });
      //console.log("availables",availables,filtered,filtered.shift());
      cvar = [filtered.shift(),false];
    }
  }
  return cvar;
}
function getAvailableGifts(available,target){
  var gifts = [];
  ////console.log("available",available);
  available.forEach(function (item, index) {
    var itemJson 	= item.json;
    var itemVar 	= itemJson.variants;
    var itemSep 	= (item.combine) ? "plus" : "ODER";
    var cvar		= getVariantJson(itemVar,item.variant,item);
    var gvar		= cvar[0];
    var avar		= cvar[1];
    //console.log("getAvailableGifts",gvar,avar);
    if(gvar.available){
      var gimg 		= itemJson.featured_image;
      var gsub 		= itemJson.type;
      if(!itemJson.product_has_only_default_variant || itemJson.variants.size > 0){
        if(gvar.hasOwnProperty('featured_media')){
          if((gvar.featured_media).hasOwnProperty('preview_image')){
            gimg = gvar.featured_media.preview_image.src;
          }
        }
        if(gvar.title != "Default Title"){
          gsub = gvar.title;
        }
      }
      var gadd 	= {quantity:parseInt(item.quantity),id:parseInt(gvar.id),properties:{'_gift':target}};
      gadd.properties['_script'] = currentScriptID;
      var cadd	= btoa(encodeURI(JSON.stringify(gadd)));
      var avar_add	= (avar) ? btoa(encodeURI(avar.join(','))) : false;
      var gift 	= {select:item.select, add:gadd, toa:cadd, qty:item.quantity, handle:itemJson.handle, url:'/products/'+itemJson.handle+'/'+gvar.id, title:itemJson.title, sub:gsub, img:gimg, sep:itemSep, avar:avar_add };
      gifts.push(gift);
    }
  });
  //console.log("gifts",gifts);
  return gifts;
}

function calculateGifts(countable){
  ////console.log("totalPriceGift",countable);
  cartGiftInfo 				= {'available':false,'pending':false,'diff':0,'till':0};
  const $giftButton			= $(".dgs-cartbar-eventbox-button[data-topnavi='gift']");
  const $giftPreload		= $(".dgs-cartbar-eventbox-content-item-box[data-gift='preload']");
  const $giftProgress		= $(".dgs-cartbar-eventbox-content-item-box[data-gift='progress']");
  const $giftPending		= $(".dgs-cartbar-eventbox-content-item-box[data-gift='pending']");
  const $giftFinished		= $(".dgs-cartbar-eventbox-content-item-box[data-gift='finished']");
  const $giftEmpty			= $(".dgs-cartbar-eventbox-content-item-box[data-gift='empty']");
  const $footer 			= $(".dgs-cartbar-footer").first();
  if(transferedGifts){
    countable = isNaN(countable) ? 0 : countable;
    var checkCode 			= checkDiscountCode();
    var giftCurrent 		= false;
    var giftNext 			= false;
    var $giftSteps 			= transferedGifts.steps;
    var $giftStepsCount		= Object.keys($giftSteps).length;
    var $giftConfig 		= transferedGifts.config;
    //var $giftConfigIncart 	= $giftConfig.incart;
    var $giftConfigIncart 	= Object.keys(cartGiftMatch);
    var $giftConfigTag 		= $giftConfig.tag;
    //var $giftIncart 		= (typeof $giftConfigIncart !== "undefined") ? $giftConfigIncart.length : 0;
    ////console.log("checkGiftMatch",cartGiftMatch,Object.keys(cartGiftMatch).length);
    var $giftIncart 		= Object.keys(cartGiftMatch).length;
    var $giftStepsKeys 		= Object.keys($giftSteps).reverse();
    sessionStorage.setItem('__t_sk_gi',btoa(encodeURIComponent(JSON.stringify($giftStepsKeys))));
    ////console.log("$giftConfig",$giftConfig,$giftConfigIncart,$giftIncart);
    const keys = Object.keys($giftSteps);
    ////console.log("$giftSteps keys",keys);
    if(transferedGifts.config.status && $giftStepsCount > 0){
      for (const [key, value] of Object.entries($giftStepsKeys)) {
        ////console.log("CHECK Key",key,value);
        var giftStep = $giftSteps[value];
        var giftStepCodes = giftStep.codes;
        var target = parseInt(value);
        ////console.log("giftStep",giftStep,giftStepCodes,target,countable);
        if(target > countable){
          if(giftStepCodes.length == 0 || giftStepCodes.includes(checkCode)){
            giftNext = $giftSteps[value];
            giftNext['target'] = target;
            giftNext['combine'] = giftStep.combine;
            giftNext['flexible'] = giftStep.flexible;
          }
        }
      }
      var $giftStepsKeys = $giftStepsKeys.reverse();
      for (const [key, value] of Object.entries($giftStepsKeys)) {
        var giftStep = $giftSteps[value];
        var giftStepCodes = giftStep.codes;
        var target = parseInt(value);
        if(!giftCurrent && target <= countable && (!$giftConfigIncart.includes(target.toString()))){
          if(giftStepCodes.length == 0 || giftStepCodes.includes(checkCode)){
            giftCurrent = $giftSteps[value];
            giftCurrent['target'] = target;
            giftCurrent['combine'] = giftStep.combine;
            giftCurrent['flexible'] = giftStep.flexible;
          }
        }
      }
      //console.log("giftCurrent",giftCurrent);
      //console.log("giftNext",giftNext);

      const giftTargetStr		= parseInt(giftCurrent['target']);
      $(".dgs-cartbar-eventbox-content-item[data-topnavi='gift']").hide();
      $(".dgs-cartbar-eventbox-content-item-box[data-gift]").hide();
      //$giftPreload.hide();
      if($giftIncart > 0){ $footer.find("*[data-replace='cart-discount-value']").html("inkl. Geschenk"); }
      ////console.log($giftConfigIncart,giftTargetStr);
      if(giftCurrent){
        giftCurrent = appendProductJSON(giftCurrent);
        ////console.log("giftCurrentProduct",giftCurrent);
        var giftCurrentDiff = parseInt(giftCurrent['target']) - parseInt(countable);
        if(giftCurrentDiff <= 0 && !$giftConfigIncart.includes(giftTargetStr.toString())){
          var available	  = availablePack($giftConfig,giftCurrent);
          var gifts 	  = getAvailableGifts(available,giftCurrent['target']);
          ////console.log("available",available,gifts,$giftStepsCount);
          if(available.length > 0){
            $giftButton.attr("data-status","available");
            var stoKey 			= '__t_gp_'+md5(gifts);
            sessionStorage.setItem(stoKey,btoa(encodeURI(JSON.stringify(gifts))));
            
            var giftSelectArr = (gifts) ? gifts.map(function(gift){ return gift.select; }) : [];
            //console.log("gifts",gifts,giftCurrent['select'],giftSelectArr);
            //if(!giftCurrent['select'] && !giftSelectArr.includes(true)){
            if(!giftCurrent['select']){
              if(gifts.length > 0 && !$giftConfigIncart.includes(giftTargetStr.toString())){
                //$(".dgs-cartbar").attr("loadercover","");
                var items	 	= [];
                gifts.forEach(function (item, index) {
                  ////console.log("item",item);
                  var addItem = item.add;
                  var founded = items.find(x => x.id === addItem.id);
                  //console.log("founded",founded);
                  if(founded){
                    founded.quantity = founded.quantity + addItem['quantity'];
                    founded.properties['_locked'] = founded.quantity;
                  }else{
                    addItem.properties['_added'] = "auto";
                    items.push(addItem);
                  }
                });
                if(!giftCurrent['combine']){
                  var firstAvailable = items[0];
                  items.length = 0;
                  items.push(firstAvailable);
                }
                ////console.log("items",items);
                addItems2Cart(items,'sys');
              }
            }else{
              cartGiftInfo['pending'] = true;
              //console.log("giftCurrent",giftCurrent);
              var langtxt			= {
                title: "Geschenk verfügbar",
                text: "Geschafft 😎 Lege jetzt dein Geschenk in den Warenkorb:"
              };
              if(gifts.length >= 2 && giftCurrent['combine']){
                langtxt['btnAdd'] = "Geschenke hinzufügen";
                langtxt['btnSelect'] = "Geschenke auswählen";
              }else{
                langtxt['btnAdd'] = "Geschenk hinzufügen";
                langtxt['btnSelect'] = "Geschenk auswählen";
              }
              var select   = (giftCurrent['select'] && gifts.length >= 2) ? true : false;
              select       = (giftCurrent['select'] && gifts.length == 1 && gifts[0].select) ? true : select;
              select       = (!giftCurrent['select']) ? false : select;
              select       = (select) ? "select" : "auto";
              //select                = (!giftCurrent['select'] && giftCurrent['combine'] && giftSelectArr.includes(true)) ? true : select;
              //select                = (!giftCurrent['select'] && !giftCurrent['combine'] && gifts[0].select) ? true : select;
              //console.log("pending",giftSelectArr.includes(true),gifts.length,giftCurrent['select'],select);
              var context 			= { langtxt:langtxt, available:gifts.length, gifts:btoa(encodeURI(JSON.stringify(gifts))), stoid:md5(gifts), select:select };
              var $render 			= handlebarTemplate("gift-pending","dgs-tpl-cart-gift-pending",context);
              $giftPending.html($render).show();
              //addGiftCartButton();
              $(".dgs-cartbar-eventbox-content-item[data-topnavi='gift']").removeAttr("style");
              var currentEventbox = $(".dgs-cartbar-eventbox").attr("data-topnavi");
              if(currentEventbox != "gift" && cartSuccessShipping){
                openCartbarEventbox("gift",0);
                var giftAvailableNotiMsg	= "<b>Geschenk verfügbar!</b> Jetzt wählen!";
                openNotification(giftAvailableNotiMsg,'success',1);
              }
              var getParameter_open 	= findGetParameter("open");
              if(getParameter_open == "gift-modal"){
                if($("cartbar").find("button[data-button='addgift']").length){ 
                  $("cartbar").find("button[data-button='addgift']").trigger("click");
                }
              }
            }
          }else{ showEmptyGift($giftStepsCount); }
        }
      }
      if(giftNext){
        giftNext = appendProductJSON(giftNext);
        ////console.log("giftNextProduct",giftNext);
        var giftNextDiff = parseInt(giftNext['target']) - parseInt(countable);
        ////console.log("giftNextDiff",giftNextDiff,$giftIncart);
        $giftButton.attr("data-status","pending");
        var available	= availablePack($giftConfig,giftNext);
        var gifts 	= getAvailableGifts(available,giftNext['target']);
        ////console.log("available",available,gifts,$giftStepsCount);
        if(available.length > 0 && !giftNext['select'] && !giftNext['combine']){
          var firstAvailable = gifts[0];
          gifts.length = 0;
          gifts.push(firstAvailable);
        }
        ////console.log("firstAvailable",gifts);
        if(gifts.length > 0){
          ////console.log("gifts",gifts);
          var giftNextDiffText	= formatNumber((giftNextDiff / 100), 2, ",", ".");
          var cartGiftText		= "Nur noch \u0026lt;b\u0026gt;[price]\u0026lt;\/b\u0026gt; bis zu deinem Geschenk 😍";
          var cartGiftText		= cartGiftText.replace("[price]",giftNextDiffText+" €*");
          var giftNotiMsg1		= "Nur noch [price] bis zum gratis Geschenk 😍";
          var giftNotiMsg1		= giftNotiMsg1.replace("[price]",giftNextDiffText+" €*");
          var percentGift			= (100 / parseInt(giftNext['target'])) * parseInt(countable);
          var percentGift			= (percentGift >= 100) ? 100 : percentGift;
          var percentGiftTill		= Math.abs(100 - percentGift);
          var langtxt			= {
            title: "Geschenk sichern",
            text: cartGiftText
          };
          cartGiftInfo['available'] = true;
          cartGiftInfo['diff'] 		= giftNextDiff;
          cartGiftInfo['till']		= percentGiftTill;
          var context 				= { langtxt:langtxt, percent:percentGift, available:gifts.length, gifts:gifts };
          var $render 				= handlebarTemplate("gift-progress","dgs-tpl-cart-gift-progress",context);
          $giftProgress.html($render).show();
          delGiftCartButton();
          setTimeout(function(){ $giftProgress.find(".dgs-cartbar-progress-status").attr("expand",1); }, 750);
          if(typeof updateGA4 !== "undefined"){ updateGA4('gift', {diff:giftNextDiff}); }
          $(".dgs-cartbar-eventbox-content-item[data-topnavi='gift']").removeAttr("style");
          var currentEventbox = $(".dgs-cartbar-eventbox").attr("data-topnavi");
          if(currentEventbox != "gift" && cartSuccessShipping){
            openCartbarEventbox("gift",0);
          }
        }else{ showEmptyGift($giftStepsCount); }
      }
      if(!giftNext && !giftCurrent){
        if($giftIncart > 0){
          $giftButton.attr("data-status","success");
          openCartbarEventbox("cart",0);
          var langtxt			= {
            title: "Geschenk hinzugefügt",
            text: "Dein Geschenk befindet sich bereits im Warenkorb 😎"
          };
          var context 			= { langtxt:langtxt };
          var $render 			= handlebarTemplate("gift-finish","dgs-tpl-cart-gift-finish",context);
          $giftFinished.html($render).show();
          delGiftCartButton();
          $(".dgs-cartbar-eventbox-content-item[data-topnavi='gift']").removeAttr("style");
        }else{
          $(".dgs-cartbar-eventbox-content-item-box[data-gift]").hide();
          showEmptyGift($giftStepsCount);
          //$footer.find("*[data-replace='cart-discount-value']").html("");
        }
      }
    }else{ hideGiftContent(); }
  }else{ hideGiftContent(); }
}
function hideGiftContent(){
  $(".dgs-cartbar-eventbox-button[data-topnavi='gift']").hide();
  $(".dgs-cartbar-eventbox-content-item[data-topnavi='gift']").hide();
  var currentEventbox = $(".dgs-cartbar-eventbox").attr("data-topnavi");
  if(currentEventbox == "gift"){ openCartbarEventbox("cart",0);    }
  delGiftCartButton();
}
function showEmptyGift(steps){
  var $giftButton			= $(".dgs-cartbar-eventbox-button[data-topnavi='gift']");
  var $giftEmpty			= $(".dgs-cartbar-eventbox-content-item-box[data-gift='empty']");
  if(steps > 0){
    $giftButton.attr("data-status","error");
    var langtxt			= {
      title: "Geschenk vergriffen",
      text: "Sorry 😟 Leider war der Andrang so groß, dass bereits alle Geschenke vergriffen sind."
    };
    var context 			= { langtxt:langtxt };
    var $render 			= handlebarTemplate("gift-empty","dgs-tpl-cart-gift-empty",context);
    $giftEmpty.html($render).show();
    delGiftCartButton();
    $(".dgs-cartbar-eventbox-content-item[data-topnavi='gift']").removeAttr("style");
  }else{ hideGiftContent(); }
}
function addGiftCartButton(){
  var $btn_cart = $(".dgs-header-button[button='cart']").first();
  var $btn_gift = $("cartbar").find("button[data-button='addgift']").first();
  var $btn_gift_onclick = $btn_gift.attr("onclick");
  $btn_cart.removeAttr("full").removeAttr("empty")
    .attr("gift","").unbind().attr("onclick",$btn_gift_onclick)
    .find("*:not(span)").addClass("dgs-infinite-wiggle");
}
function delGiftCartButton(){
  var $btn_cart = $(".dgs-header-button[button='cart']").first();
  $btn_cart.unbind().attr("onclick","toggleCartbar(0);").removeAttr("gift")
  .attr("full","").find("*:not(span)").removeClass("dgs-infinite-wiggle");
}
function addGiftPack(gifts,type = 'sys'){
  var items	 	= [];
  //console.log("addGiftPack",gifts);
  var giftsObj = decodeURI(atob(gifts));
  var giftsObjPar = JSON.parse(giftsObj);
  ////console.log("giftsObjPar",giftsObjPar);
  if(giftsObjPar.length > 0){
    giftsObjPar.forEach(function (item, index) {
      items.push(item.add);
    });
    let requestBody = {'items': items};
    if(cartFetchBundle){ requestBody['sections'] = 'dgs-cart-sidebar'; }
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      headers: {'Content-Type': 'application/json'},
      method: 'POST',body: JSON.stringify(requestBody)})
    .then(response => {
      if(response.ok){ return response.json(); }
      else{ throw new Error('Something went wrong'); }
    }).then(data => { afterFetch(data,'add','sys'); })
    .catch(error => { fetchFailed(); })
    .finally(() => { $("*[loadercover]").removeAttr("loadercover").prop("disabled", false); });
  }
}
function addGiftItem(gift,type = 'sys'){
  $(".dgs-gift-list").find("button").prop("disabled", true)
  .parent().attr("loadercover","");
  $("div[data-loading='"+gift+"']").attr("loadercover","");
  var items	 	= [];
  var giftObj = decodeURI(atob(gift));
  var giftObjPar = JSON.parse(giftObj);
  if(giftObjPar.quantity > 0){
    giftObjPar.properties['_script'] = currentScriptID;
    items.push(giftObjPar);
    //console.log("addGiftItem",items);
    addItems2Cart(items,type);
  }
}
function selectGiftModal(sessionID){
  var stoKey 	= '__t_gp_'+sessionID;
  if(sessionStorage.getItem(stoKey)){
    var stoDat = sessionStorage.getItem(stoKey);
    var giftsObj 		= JSON.parse(decodeURI(atob(stoDat)));
    var con_gifts		= giftsObj.filter(gift => gift.add.quantity > 0);
    ////console.log(con_gifts);
    var con_wraps		= parseInt(12 / con_gifts.length).toFixed(0);
    var langtxt			= {
      title: "Wähle dein Geschenk",
      btnAdd: "Geschenk hinzufügen"
    };
    var context 		= { langtxt:langtxt, wraps:con_wraps, gifts:con_gifts };
    ////console.log("context",context);
    handlebarTemplate("gift-modal","dgs-tpl-cart-gift-modal",context,"modal");
  }
}
function deleteGiftpack(giftpack){
  $(".dgs-cartbar-button").prop("disabled", true);
  $(".dgs-cartbar-item[giftpack='"+giftpack+"']").find(".dgs-cartbar-item-response").attr("data-response","delete").fadeIn();
  $(".dgs-cartbar-item[giftpack='"+giftpack+"']").find("input[name='quantity']").val(0);
  updateCartFull('form-cart-sidebar','sys',100);
}
function openGiftModal(sessionID){
  if($("cartbar").find("button[data-button='addgift']").length){
    $(this).attr("loadercover","").prop("disabled", true);
  }
  configURL("change","add","return","cartbar");
  var stoKey 	= '__t_gp_'+sessionID;
  var section = 'dgs-tpl-giftmodal';
  if(sessionStorage.getItem(stoKey)){
    var stoDat = sessionStorage.getItem(stoKey);
    var giftsObj 		= JSON.parse(decodeURI(atob(stoDat)));
    //console.log(giftsObj);
    var con_config = [];
    var con_gifts = (giftsObj) ? giftsObj.map(function(gift){ 
      if(!con_config.length){
        var target = gift.add.properties['_gift'];
        var step = transferedGifts.steps[parseInt(target)];
        con_config.push((step.combine) ? "plus" : "ODER");
        con_config.push(step.combine);
        con_config.push(step.select);
        con_config.push(target);
      }
      var cta = (!gift.select) ? gift.toa : 'select';
      return (gift.url).replace("/products",gift.qty)
        + "/" + cta.replace("=","$")
        + "/" + ((gift.avar) ? (gift.avar).replace("=","$") : 'false'); 
    }) : [];
    con_gifts		= JSON.stringify(con_gifts);
    con_config		= JSON.stringify(con_config.join(','));
    //console.log(con_gifts,con_config);
    var fetchURL = window.Shopify.routes.root;
    fetchURL = fetchURL+'?sections='+section;
    fetchURL = renderSectionQuery(fetchURL,"config",con_config);
    fetchURL = renderSectionQuery(fetchURL,"gifts",con_gifts);
    fetch(fetchURL).then(response => {
      if(response.ok){ return response.json(); closeCartbar(); }
      else{ throw new Error('Something went wrong'); }
    }).then(data => { 
      if(data.hasOwnProperty(section)){
        var giftModal = data[section].split("###");
        var $render = giftModal[1];
        ////console.log("giftModal",$render);
        //rememberModal = "openModal('Handlebars','"+btoa(encodeURI($render))+"','cart-product-modal',0,0)";
        openModal('Handlebars',$render,"gift-modal",0,0);
      }else{ fetchFailed(); }
    }).catch(error => { fetchFailed(error); })
    .finally(() => { $("*[loadercover]").removeAttr("loadercover").prop("disabled", false); });    
  }else{ fetchFailed(); }
}
function selectableGift(target,items){
  var itemsObj 		= JSON.parse(decodeURI(atob(items)));
  //console.log("selectableGift",items,itemsObj);
  
  var giftsArr	= [];
  var $giftList	= $("div.dgs-gift-list"); 
  var $giftItems	= $giftList.find(".dgs-gift-item");
  $(".dgs-modal[modal-type='gift-modal']").find(".dgs-gift-buttons")
    .attr("loadercover","").find("button").prop("disabled", true);
  $giftItems.each(function(index){
    var $giftData       = $(this).find("form");
    var giftVariant 	= parseInt($giftData.find("select[data-type='product-variant']").val());
    var giftHandle 		= $giftData.find("select[data-type='product-variant']").attr("data-handle");
    var giftKey         = md5(giftHandle + "_" + index);
    var giftItem 	    = {'id':giftVariant,'properties':{'_gift':parseInt(target),'_script':currentScriptID}};
    if(itemsObj.hasOwnProperty(giftKey)){
      giftItem['quantity'] = itemsObj[giftKey].quantity;
      giftItem.properties['_locked'] = giftItem['quantity'];
      if((itemsObj[giftKey]).hasOwnProperty('pfand')){
        if(itemsObj[giftKey]['pfand'] > 0){
          giftItem.properties['_pfand'] = itemsObj[giftKey].pfand;
        }
      }
    }
    var founded = giftsArr.find(x => x.id === giftVariant);
    //console.log("founded",founded);
    if(founded){
      founded.quantity = founded.quantity + giftItem['quantity'];
      founded.properties['_locked'] = founded.quantity;
    }else{
      giftsArr.push(giftItem);
    }
  }).promise().done(function(){
    //console.log("giftsArr",giftsArr);
    addItems2Cart(giftsArr,"sys");
  });
}
function renderRecom2Cart(elm = false,context = false, loaded = false){
  loaded = (loaded && cartRecomCache) ? true : false;
  console.log("renderRecom2Cart",cartSigCode);
  if(elm && context){
    if(!loaded){
      var $render 	    = handlebarTemplate("cart-recom","dgs-tpl-cart-recom",context);
      elm.replaceWith($render);
    }
    setTimeout(async function(){
      $("cartbar").find(".dgs-cartbar-item.recomProduct").attr("show","");
      await sleep(350); checkImgLoader(); checkViewport();
    },350);
  }
}
function addRecom2Cart(pid = false,intent = 'related',index = false){
  var $recomItem = $("cartbar").find(".dgs-cartbar-item.recomProduct");
  var currentSigCode = (!!sessionStorage.getItem("__t_ars")) ? sessionStorage.getItem("__t_ars") : false;
  var recomLoaded = ($recomItem.find(".dgs-cartbar-item-product[data-sig='"+currentSigCode+"']").length) ?? false;
  //console.log("__t_ars",currentSigCode,cartSigCode,recomLoaded);
  var cartbarOpen    = parseInt($("body").attr("data-cartbar"));
  var recomContext 	 = false;
  //console.log("addRecom2Cart",recomContext,cartRecomItems,cartRecomCache);
  if(cartRecomItems && cartbarOpen == 1){
    if(cartRecomCache){
      //console.log("addRecom2Cart",(cartSigCode == currentSigCode));
      if(cartSigCode == currentSigCode){
        var recomCache 		= sessionStorage.getItem('__t_arc');
        //console.log("addRecom2Cart",recomCache);
        if(recomCache){
          var recomParsed 	= JSON.parse(decodeURI(atob(recomCache)));
          //console.log("addRecom2Cart",recomParsed,recomParsed.hasOwnProperty('handle'));
          if(recomParsed.hasOwnProperty('handle')){
            recomContext      = recomParsed;
          }
        }
      }
    }
    //console.log("addRecom2Cart",$recomItem.length,recomContext);
    if(!cartRecomCache || !recomContext){
      if(!pid && $recomItem.length){
        var pid = ($recomItem.attr("data-pid")) ? $recomItem.attr("data-pid") : pid;
        var index = ($recomItem.attr("data-index")) ? $recomItem.attr("data-index") : index;
      }
      //console.log("addRecom2Cart",$recomItem.length,pid,index);
      if($recomItem.length && pid && index){
        fetch(window.Shopify.routes.root + "recommendations/products.json?product_id="+pid+"&limit=6&intent="+intent)
        .then(response => response.json()).then(({ products }) => {
          //console.log("addRecom2Cart",products.length,rejectedOrSelectedProducts,allowedRecommendations,firstAvailableVariants);
          if(products.length > 0 && rejectedOrSelectedProducts && allowedRecommendations && firstAvailableVariants){
            products = products.filter(product => (product.tags).indexOf('hidden') < 0);
            products = products.filter(product => (product.tags).indexOf('bundle') < 0);
            if(cartRejected){ products = products.filter(product => rejectedOrSelectedProducts.indexOf(product.handle) < 0); }
            products = products.filter(product => allowedRecommendations.indexOf(product.handle) >= 0);
            //console.log("addRecom2Cart",products,products.length);
            if(products.length > 0){
              var randomKey   = getRandomInt(0, (products.length - 1));
              const recomProduct = products[randomKey];
              var lastSeen 		= localStorage.getItem('__t_lsp');
              var lastSeenObj 	= (!lastSeen) ? {} : JSON.parse(lastSeen);
              //console.log("addRecom2Cart",recomProduct.handle,lastSeenObj,lastSeenObj[recomProduct.handle]);
              if(lastSeenObj[recomProduct.handle]){
                var recomVar 	    = lastSeenObj[recomProduct.handle];
                var recomVarId 	= recomVar.variant;
                var recomImg 	    = recomVar.img.url;
                var recomScale 	= recomVar.img.scale;
                //console.log("addRecom2Cart",lastSeenObj,recomVar,recomVarId);
              }else{
                var recomVar 	    = firstAvailableVariants[recomProduct.handle];
                var recomVarId 	= recomVar.id;
                var recomImg 	    = recomVar.img;
                var recomScale 	= recomVar.scale;
                //console.log("addRecom2Cart",firstAvailableVariants,recomVar,recomVarId);
              }
              if(recomVarId){
                var recomId         = 'add2cart_' + (recomProduct.id) + '_' + index;
                var recomSubtitle   = stripHTML(recomProduct.description);
                recomSubtitle       = truncateStr(recomSubtitle,48);
                recomContext 	    = { handle:recomProduct.handle, pid:pid, vid:recomVarId, rid:recomId, index:index, img:recomImg, scale:recomScale, headline:recomProduct.title, subtitle:recomSubtitle, sig:currentSigCode };
                if(cartRecomCache){
                  cartSigCode = currentSigCode;
                  sessionStorage.setItem('__t_arc',btoa(encodeURI(JSON.stringify(recomContext))));
                }
                renderRecom2Cart($recomItem,recomContext,recomLoaded);
              }
            }
          }
        });
      }
    }else{
      renderRecom2Cart($recomItem,recomContext,recomLoaded);
    }
  }
}
function switchResizedImg($selector,img,preview = false){
  $selector.attr("switch","");
  var preimg = (preview) ? preview : "";
  if(preview){ $selector.attr("data-pre",preimg).css("backgroundImage","url('"+preimg+"')"); }
  var imgFaktor = $selector.attr("img-faktor");
  var imgDPI 	= parseInt(window.devicePixelRatio);
  var imgDPI 	= (imgDPI > 1 && typeof imgDPI !== "undefined") ? imgDPI : 1;
  var imgScale 	= (typeof imgFaktor !== "undefined" && imgDPI < 3) ? parseFloat(imgFaktor) : imgDPI;
  var imgScale 	= (imgScale >= 2) ? 2 : imgScale;
  var image 	= resizeImage($selector,img,imgScale);
  $selector.removeAttr("switch").attr("imgloader","").attr("imgloading","");
  $('<img/>').attr('src',image).on('load', function() {
    $(this).remove();
    $selector.attr("data-img",image).css("backgroundImage","url('"+image+"')")
    .removeAttr("switch").removeAttr("imgloader").removeAttr("imgloading");
    if($(".dgs-details-background").length){
      $(".dgs-details-background").attr("loaded","");
    }
  });
}
function renderSectionQuery(fetchURL,key,value){
  return fetchURL+"&"+key+"="+value;
}
function fetchSection(target,section,root = "/",query = {}){
    var fetchURL = root;
    var timestamp = new Date().getTime();
    if(query.hasOwnProperty('tagged') && query.tagged != ""){ fetchURL = fetchURL+'/tagged/'+query.tagged; }
    fetchURL = fetchURL+'?sections='+section;
    if(query.hasOwnProperty('step') && query.step != ""){ fetchURL = renderSectionQuery(fetchURL,"step",query.step); }
    ////console.log("fetchURL",fetchURL);
    fetch(fetchURL, {cache: "no-cache"}).then(function(response){
      ////console.log(response);
      if(!response.ok){ sectionLoadingFailed(section,target,response.status); }
      return response.text();
    }).then(function(response) {
      var response = JSON.parse(response);
      ////console.log(data);
      if(target == "return"){
        return response[section];
      }else{
        $("#"+target).attr("import","");
        $("#"+target).html(response[section]).promise().done(function() { 
          checkViewport(); checkImgLoader();
          calculateDiscounts();
          $("#"+target).removeAttr("import")
          .removeAttr("secloader").removeAttr("loading")
          .attr("loaded","");
        });
      }
    }).catch(function(error){
      sectionLoadingFailed(section,target,error.status);
    });

}
async function renderSectionAsync(target,section,root = "/",query = {}){
  if(finishedLoadingScripts){
    var fetchURL = root;
    var timestamp = new Date().getTime();
    if(query.hasOwnProperty('tagged') && query.tagged != ""){ fetchURL = fetchURL+'/tagged/'+query.tagged; }
    fetchURL = fetchURL+'?sections='+section;
    if(query.hasOwnProperty('page') && query.page != ""){ fetchURL = renderSectionQuery(fetchURL,"page",query.page); }
    if(query.hasOwnProperty('variant') && query.variant != ""){ fetchURL = renderSectionQuery(fetchURL,"variant",query.variant); }
    if(query.hasOwnProperty('step') && query.step != ""){ fetchURL = renderSectionQuery(fetchURL,"step",query.step); }
    var getParameter_view	= findGetParameter("view");
    if(getParameter_view !== null){ fetchURL = renderSectionQuery(fetchURL,"view",getParameter_view); }
    var getParameter_show	= findGetParameter("show");
    if(getParameter_show !== null){ fetchURL = renderSectionQuery(fetchURL,"show",getParameter_show); }
    var getParameter_hide	= findGetParameter("hide");
    if(getParameter_hide !== null){ fetchURL = renderSectionQuery(fetchURL,"hide",getParameter_hide); }
    if(section == "dgs-product-quotes"){ fetchURL = fetchURL + "&"+timestamp; }
    ////console.log("fetchURL",fetchURL);
    await fetch(fetchURL, {cache: "no-cache"}).then(function(response){
      ////console.log(response);
      if(!response.ok){ sectionLoadingFailed(section,target,response.status); }
      return response.text();
    }).then(function(response) {
      var response = JSON.parse(response);
      ////console.log(data);
      if(target == "return"){
        return response[section];
      }else{
        $("#"+target).attr("import","");
        $("#"+target).html(response[section]).promise().done(function() { 
          checkViewport(); checkImgLoader();
          calculateDiscounts();
          $("#"+target).removeAttr("import")
          .removeAttr("secloader").removeAttr("loading")
          .attr("loaded","");
          //}, 50);
        });
      }
    }).catch(function(error){
      sectionLoadingFailed(section,target,error.status);
    });
  }
}
function initialSectionAsync(target,section,root = "/",query = {}){
  ////console.log("initialSectionAsync",$("#"+target).length);
  if($("#"+target).length){
    if($("#"+target).isInViewport() && finishedLoadingScripts){
      renderSectionAsync(target,section,root,query);
    }else{      
      var prerender = rootURL+'?sections='+section;
      ////console.log(!!($("head").find("link[rel='prerender'][data-section='"+section+"']")).length);
      if(!!($("head").find("link[rel='prerender'][data-section='"+section+"']")).length == false){
        //$("head").append('<link rel="prerender" data-section="'+section+'" href="'+prerender+'">');
      }
      var sectionConfig = {'target':target,'section':section,'root':root,'query':query};
      $("#"+target).attr("secloader",JSON.stringify(sectionConfig)).attr("dgs-viewport","");
    }
  }
}
function checkSectionAsync(){
  ////console.log("checkSectionAsync",$('*[secloader]:not([loading])').length);
  if($('*[secloader]:not([loading])').length && !showRendering){
    $('*[secloader]:not([loading])').each(function(){
      var target = $(this).attr("id");
      ////console.log("scroll",target);
      if($("#"+target).isInViewport()){
        $("#"+target).attr("loading","");
        var secloader = $("#"+target).attr("secloader");
        if(typeof secloader !== 'undefined' && secloader !== false) {
          var sc = JSON.parse(secloader);
          ////console.log("render",sc);
          renderSectionAsync(sc.target,sc.section,sc.root,sc.query);
        }
      }
    });
  }
}
function asyncScriptLoader(scripts = []){
  for (var i = 0; i < scripts.length; i++) {
    var url = scripts[i];
    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = url;
    s.crossorigin = "anonymous";
    var x = document.getElementsByTagName('script')[0];
    x.parentNode.insertBefore(s, x);
    s.onload = () => {
      loadedAsyncScripts++;
      ////console.log(loadedAsyncScripts,showRendering);
      if(loadAsyncScripts.length == loadedAsyncScripts){
        finishedLoadingScripts = true;
        if(typeof initDomGA4 !== "undefined"){ initDomGA4(); }
        if(typeof initialPopupStart !== "undefined"){ initialPopupStart(); }
        if(typeof initialThemeStart !== "undefined"){ initialThemeStart(); }
        if(typeof initialCartbarStart !== "undefined"){ initialCartbarStart(); }
        if(typeof initialCalculatorStart !== "undefined"){ initialCalculatorStart(); }
        if(typeof initialInfluencerStart !== "undefined"){ initialInfluencerStart(); }
        if(typeof initialClosepageStart !== "undefined"){ initialClosepageStart(); }
        if(typeof initialDownpageStart !== "undefined"){ initialDownpageStart(); }
        if(typeof initSectionFactslider !== "undefined"){ initSectionFactslider(); }
        if(typeof initialMore2winStart !== "undefined"){ initialMore2winStart(); }
        if(typeof initialSubstituteStart !== "undefined"){ initialSubstituteStart(); }
        if(typeof initialSubstituteStart !== "undefined"){ initialSubstituteStart(); }
        if(typeof initialContentStart !== "undefined"){ initialContentStart(); }
        if(typeof initialFwfModal !== "undefined" && (fwfModalEnable || 1 == 1)){ initialFwfModal(); }
        if(typeof checkSectionAsync !== "undefined" && !showRendering){ checkSectionAsync(); }
        //if(typeof checkCart !== "undefined"){ checkCart(JSON.stringify(cartJSON),false,true); }
        // Tabs überwachen und aktualisieren
        
        //window.addEventListener('blur', function(){ eventHideShop('focus'); });
        //window.addEventListener('focus', function(){ eventShowShop('focus'); });
        //window.addEventListener('scroll', function(){ window.focus(); });
        //console.clear();
        console.log('%cDeveloped with ❤️ by Datora Websystems', 'font-size:1.2em;font-weight:400;color:#fff; background-color:#0297b7; padding:5px 10px; margin:20px 0; border-radius:6px;');
        //console.log = function() { }
        
      }
    } 
  }
}

function eventShowShop(type){
  if(refreshCartbar){
    refreshCartbar = false;
    refreshCartSection();
  }
}
function eventHideShop(type){
  if(!beforeLoadePage){
    refreshCartbar = true;
    allowModalOpen = false;
  }
}
function checkCart(cartJSON, reload = false, mutation = false){
  //console.log("1",cartJSON);
  if (!cartJSON) return false;
  var cartJSON 		    = JSON.parse(cartJSON);
  //console.log("2",cartJSON);
  //if(cartJSON.hasOwnProperty('items')
  var cartGift 		    = false;
  var cartGiftChanged 	= false;
  cartGiftMatch         = {};
  var cartPfandItem	    = false;
  var cartPfandCount	= 0;
  var cartCoolItem      = false;
  var cartCoolCount	    = 0;
  var cartCalcKey		= false;
  var cartCalcCode		= false;
  var cartScriptID 		= false;
  var cartTransfer      = false;
  var cartCalcProps     = false;
  var cartGiftFwF       = false;
  var cartAttr          = false;
  checkCode		= checkDiscountCode();
  for(i = 0; i < cartJSON.items.length; i++){
    var item = cartJSON.items[i];
    if(item.properties !== null){
      if((item.properties).hasOwnProperty('_gift') && !(item.properties).hasOwnProperty('_winid')){
        cartGift 		= true;
        cartGiftTarget = item.properties['_gift'];
        cartGiftMatch[cartGiftTarget] = {'handle':item.handle, 'vid':item.id, 'qty':item.quantity};
        if((item.properties).hasOwnProperty('__action')){
          if(item.properties['__action']){
            cartGiftChanged = true;
          }
        }
      }
      if((item.properties).hasOwnProperty('_pfand')){ 
        cartPfandCount 	= cartPfandCount + (parseInt(item.properties['_pfand']) * parseInt(item.quantity));
      }
      if((item.properties).hasOwnProperty('_extra')){
        if(item.properties['_extra'] == "freeshipping"){ cartFreeshipping = true; }
      }
      if((item.properties).hasOwnProperty('_added') && (item.properties).hasOwnProperty('_winid')){
        if(item.properties['_added'] == "fwf"){ cartGiftFwF = true; }
      }
      if((item.properties).hasOwnProperty('_coolshipping')){ 
        cartCoolCount 	= cartCoolCount + parseInt(item.quantity);
      }
    }
    if(item.variant_id == cartCalcDummy){
      cartCalcKey = item.key;
      cartCalcProps = item.properties;
      cartCalcCode = ((item.properties).hasOwnProperty('__discount')) ? item.properties['__discount'] : false;
      cartCalcCode =  (cartCalcCode && cartCalcCode != "none") ? cartCalcCode : false;
      if((item.properties).hasOwnProperty('__transfer')){
        var transfer = item.properties['__transfer'];
        var transferJSON = JSON.parse(transfer) ?? {};      
        transferedEvents = transferJSON.events;
        if(transferJSON.hasOwnProperty('fixed')){
          if(transferJSON.fixed){
            transferedEvents = prependFixedEvents(transferJSON.events,transferJSON.fixed);
          }
        }
        if((item.properties).hasOwnProperty('__tiered')){
          var eventIndex = transferedEvents.map(object => object.id).indexOf('tiered');
          if(eventIndex >= 0){
            var tieredEvent = transferedEvents[eventIndex];
            tieredEvent['current'] = JSON.parse(item.properties['__tiered']);
            transferedEvents[eventIndex] = tieredEvent;
          }
        }
        transferedGifts = transferJSON.gifts;
        cartTransfer = true;
      }
      if((item.properties).hasOwnProperty('__scriptid')){
        cartScriptID = parseInt(item.properties['__scriptid']);
      }
    }
    if(item.handle == "pfand"){ cartPfandItem 	= item.id; }
    if(item.handle == "coolshipping"){ cartCoolItem 	= item.id; }
  }
  var cartbarOpen = parseInt($("body").attr("data-cartbar"));
  //console.log(Object.keys(cartJSON?.attributes).length,!cartCalcProps?.['__attr']);
  //console.log(cartCoolItem,cartCoolCount,ngtCoolshipping);
  if(cartCalcKey && Object.keys(cartJSON?.attributes).length > 0 && !cartCalcProps?.['__attr']){
    var changeProps = cartCalcProps;
    changeProps['__attr'] = cartJSON?.attributes;
    updateItem({'id':cartCalcKey.toString(), 'quantity':1, 'properties':changeProps},'sys');
  }else if(cartCalcKey && !cartGiftFwF && cartJSON?.attributes?.fwf == "friends"){
    let requestBody = {attributes:{'fwf':null,'c_id':null,'c_fname':null,'c_lname':null,'c_email':null}};
    fetch(window.Shopify.routes.root + 'cart/update.js', { method: 'POST',
    headers: {'Content-Type': 'application/json'}, body: JSON.stringify(requestBody) })
    .then(response => { if(response.ok){ return response.json(); } }).then(data => { 
      var changeProps = cartCalcProps;
      changeProps['__attr'] = data.attributes;
      updateItem({'id':cartCalcKey.toString(), 'quantity':1, 'properties':changeProps},'sys');
    });
  }else if(mutation){
    if(cartCalcKey && checkCode != cartCalcCode){
      var changeProps = cartCalcProps;
      var changeDiscount = (checkCode) ? checkCode : 'none';
      changeProps['__discount'] = changeDiscount;
      ////console.warn("changeCode"); 
      updateItem({'id':cartCalcKey.toString(), 'quantity':1, 'properties':changeProps},'sys');
    }else if(!checkCode && !cartCalcKey){
      var items = [{'id':parseInt(cartCalcDummy), 'quantity':1, 'properties':{'__scriptid':getScriptID, '__discount':'none'}}];
      ////console.warn("addNoCode"); 
      addItems2Cart(items,'sys');
    }else if(checkCode && !cartCalcKey){
      var items = [{'id':parseInt(cartCalcDummy), 'quantity':1, 'properties':{'__scriptid':getScriptID, '__discount':checkCode}}];
      ////console.warn("addCode"); 
      addItems2Cart(items,'sys');
    }else if(cartGift && cartGiftChanged){
      ////console.warn("updateGift"); 
      updateCartFull('form-cart-sidebar','sys',0);
    }else if(cartGift && deleteSoldoutGift){
      ////console.warn("delGift"); 
      $(".dgs-cartbar-item[data-gift='1']").find("input[name='quantity']").val(0);
      updateCartFull('form-cart-sidebar','sys',100);
      //updateItem({'id':deleteSoldoutGift.toString(), 'quantity':0},'sys');
    }else if(cartCalcKey && getScriptID != cartScriptID){
      ////console.warn("delCode"); 
      updateItem({'id':cartCalcKey.toString(), 'quantity':0},'sys');
    }else if(!cartPfandItem && cartPfandCount > 0){
      ////console.warn("addPfand"); 
      addItems2Cart([{'id':pfandID, 'quantity':cartPfandCount}],'sys');
    }else if(!cartCoolItem && cartCoolCount > 0 && ngtCoolshipping){ 
      addItems2Cart([{'id':coolShippingId, 'quantity':1}],'sys');
    }else{
      if(reload){ refreshCartSection(); }
      else{
        if($("cartbar").length){ startCartbar(JSON.stringify(cartJSON)); }
        if(cartTransfer){ calculateDiscounts(cartJSON.items); }
      }
    }
  }
}
function hasNumber(str){ return /\d/.test(str); }
function toggleFullScreen(element){if(!document.fullscreenElement){element?.requestFullscreen();}else{document.exitFullscreen();}}
var timeoutErr = false
var permissionRevokedErr = false
async function getPosition() {
  try {
    const position = await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, {timeout: 5000 });
    });
    return position;
  } catch (error) {
    console.log("catch in getposition error",error)
    if(error.code === 3){
      timeoutErr = true
      return
    }
    if(error.message === "The permission was revoked" ){
        const permissionStatus = await navigator.permissions.query({ name: 'geolocation' });
        if (permissionStatus.state === 'granted') {
          permissionRevokedErr = true
          return
        }
      }
    throw error;
  }
}

async function createEFP(){
  if(typeof deviceAPI === "undefined" || !deviceAPI || !("geolocation" in navigator)){return false}
    try {
    var latitude
    var longitude
    const position = await getPosition();
    if(timeoutErr === true || permissionRevokedErr === true ){
      latitude = geolocation.location.latitude
      longitude = geolocation.location.longitude
    }else{ 
    latitude = position.coords.latitude
    longitude = position.coords.longitude
    }
    latitude = (Math.round(latitude*1000)/1000).toFixed(3);
    longitude = (Math.round(longitude*1000)/1000).toFixed(3);
    const screenSize = screen.width * screen.height;
    const areaSize = latitude + "-" + longitude;
    const deviceCI = deviceAPI.deviceBrand + "-" + deviceAPI.deviceName;
    const deviceOS = deviceAPI.osName + "-" + deviceAPI.osVersion;

    const returnEFP = {
      "ds": Math.round(screenSize),
      "as": md5(areaSize),
      "ip": md5(geolocation.userIP),
      "ci": md5(deviceCI),
      "os": md5(deviceOS)
    };
  return Object.keys(returnEFP).sort().reduce((a, c) => (a[c] = returnEFP[c], a), {});
}catch (error) {
    
    console.warn(error.message);
    return null; // Return null or any appropriate value if an error occurs
  }
}
// Freunde werben Freunde
async function fwfExpiredCode(id){
  let obj = { expired: true };
  //console.log("fwfExpiredCode",id,obj);
  const path = `/apps/fwf/customer/friend/`+id;
  const body = JSON.stringify(obj); 
  const response = await fetch(path, { method: "PUT", headers: { "Content-Type": "application/json" }, body });      
  const data = await response.json();
  //console.log(response, data);
  if(response.ok){
    //document.location.href="/account?view=fwf-main";
    openNotification('Code wurde entwertet!','success',1);
  }else{ errorNoti(); }
}
function fwfDirectAdd2Cart(cryp,fid){
  var fwfDirect = decodeURI(atob(cryp));
  var fwfDirectArr = fwfDirect.split('|');
  //console.log(fwfDirectArr);
  var fwfDirectItems = [{quantity: 1, id: fwfDirectArr[1].toString(), properties: {'_extra': 'freeshipping', '_gift': 'winid', '_method': 'substitute', '_label': fwfDirectArr[3], '_winid': fwfDirectArr[2], '_added': 'fwf', '_fid': fid}}];
  //currentForm = false;
  addItems2Cart(fwfDirectItems,'sys');
}
async function fwfCheckGiftFriend(code,createdAt,origin,fid = false){
  var fwfAddLink = window.location.origin + "/?fid=" + fid;
  var fwfRestTs = new Date(createdAt + fwfOutdateMs);
  var timeNow = Math.round(new Date().getTime());
  console.log("fwfRestTs",fwfRestTs,timeNow);
  if(timeNow < fwfRestTs && 1 == 1){
    var fetchURL = window.Shopify.routes.root + "apps/supportCenter/code?";
    //console.log("hash-query:","code="+code );
    var hash = sha256.hmac.create("e0b2ea3ee8b4b00a1de21effdcd9fb4de4b32080")
    .update("code="+code ).hex();
    fetchURL = fetchURL + "code=" + code  + "&hash=" + hash;
    //console.log(fetchURL);
    const substituteResponse = await fetch(fetchURL);
    //console.log("substituteResponse",substituteResponse);
    if(substituteResponse.ok){
      const substituteBody = await substituteResponse.json();
      //console.log("substituteBody",substituteBody);   
      if(!substituteBody?.code?.discardedAt && !substituteBody?.code?.redeemedAt){
        var handle = substituteBody?.code?.handle;
        if(handle){
          jQuery.getJSON(window.Shopify.routes.root + 'products/'+handle+'.js', function(product) {
            var fwfDirect = product.handle + "|" + product.variants[0].id + "|" + code + "|NEUKUNDE|fwfs";
            var fwfDirectCryp = btoa(encodeURI(fwfDirect));
            fwfDirectAdd2Cart(fwfDirectCryp,fid);
            var fwfRestTxt = (fwfRestTs.getDate()).toString().padStart(2, '0') + "." + (fwfRestTs.getMonth() + 1).toString().padStart(2, '0') + "." + fwfRestTs.getFullYear();
            var context 		= { vname:customerFirstName, date:fwfRestTxt, url:fwfAddLink, id:fid };
            if(origin == "cookie"){
              setTimeout(function(){ handlebarTemplate("fwf-added","dgs-tpl-fwf-added",context,"modal"); }, 750);
            }else{
              allowModalConfetti = true;
              if(fid){ setcookie('__mn_fwf_fid',fid); }
              setTimeout(function(){ handlebarTemplate("fwf-activated","dgs-tpl-fwf-activated",context,"modal"); }, 750);
            }
          });
        }else{ deleteCookie('__mn_fwf_fid'); }
      }else if(substituteBody?.code?.redeemedAt){
        deleteCookie('__mn_fwf_fid');
        openNotification('Neukund:innen-Geschenk bereits eingelöst! 🙌','error',1);
      }else if(substituteBody?.code?.discardedAt){
        deleteCookie('__mn_fwf_fid');
        openNotification('Neukund:innen-Geschenk wurde abgelehnt!','error',1);
      }else{ errorNoti(); }
    }else{ errorNoti(); }
  }else{
    var btnShopLink = rootURL + "/pages/categories";
    setTimeout(function(){
      if(getCookie('__mn_fwf_fid')){
        handlebarTemplate("fwf-expired","dgs-tpl-fwf-expired",{'url':btnShopLink},"modal");
      }
    }, 500);
    deleteCookie('__mn_fwf_fid');
  }
}
async function fwfUpdateFriend(id){
  if(!(__st.pageurl).includes('fwf-share') && !(__st.pageurl).includes('fwf-main') && !(__st.pageurl).includes('fwf-invite')){
    let obj = { id:id, handle:fwfGiftFriendHandle, name:customerFirstName };
    //console.log(obj);
    const path = `/apps/fwf/f/ref`;
    const body = JSON.stringify(obj); 
    const response = await fetch(path, { method: "PUT", headers: { "Content-Type": "application/json" }, body });      
    const data = await response.json();       
    //console.log(response, data);
    deleteCookie('__mn_fwf_cid');
    deleteCookie('__mn_fwf_sid');
    if(response.ok){
      //document.location.href="/account?view=fwf-main";
      openNotification('Dein Account wurde erfolgreich aktualisiert','success',1);
      var fwfCreated = data.friend.createdAt;
      fwfCreated = new Date(fwfCreated);
      var fwfCreatedTs = fwfCreated.getTime();
      fwfCheckGiftFriend(data.friend.code,fwfCreatedTs);
    }else{
      if(response.status === 409){
        var context 		= { vname:customerFirstName };
        handlebarTemplate("fwf-existing","dgs-tpl-fwf-existing",context,"modal");
      }else{ errorNoti(); }
    }
  }
}
async function getFwfFriendsCustomer(addAttr = false){
  $("script[gffc]").remove();
  const path = `/apps/fwf/friend/customer`;
  const response = await fetch(path);      
  const data = await response.json()        
  //console.log(cartJSON);
  if(response.ok){
    if(addAttr && data?.customer){
      let requestBody = {attributes:{
        'fwf':'friends',
        'c_id':data.customer['id'],
        'c_fname':data.customer['firstName'],
        'c_lname':data.customer['lastName'],
        'c_email':data.customer['email']
      }};
      if(cartJSON?.attributes?.fwf != "friends"){
        await fetch(window.Shopify.routes.root + 'cart/update.js', { method: 'POST',
        headers: {'Content-Type': 'application/json'}, body: JSON.stringify(requestBody) })
        .then(response => { if(response.ok){ return response.json(); } }).then(async data => { 
          var dummyObj = getObjFromArrayByValueOfKey(data.items, 'variant_id', parseInt(cartCalcDummy));
          var dummyKey = dummyObj?.key;
          var dummyProp = dummyObj?.properties;
          dummyProp['__attr'] = data.attributes;
          let requestBody = {'id':dummyKey.toString(), 'quantity':1, 'properties':dummyProp};
          await fetch(window.Shopify.routes.root + 'cart/change.js', {method: 'POST',
          headers: {'Content-Type': 'application/json'}, body: JSON.stringify(requestBody) })
          .then(response => { if(response.ok){ return response.json(); } }).then(data => { checkCart(JSON.stringify(data), false, true); });
        });
      }
      $("#cart-fwf-data")
      .append("<input type='hidden' name='attributes[c_id]' value='"+data.customer['id']+"' readonly dgs-hidden-important>")
      .append("<input type='hidden' name='attributes[c_fname]' value='"+data.customer['firstName']+"' readonly dgs-hidden-important>")
      .append("<input type='hidden' name='attributes[c_lname]' value='"+data.customer['lastName']+"' readonly dgs-hidden-important>")
      .append("<input type='hidden' name='attributes[c_email]' value='"+data.customer['email']+"' readonly dgs-hidden-important>");
    }
  }else{
    openNotification('Da ist wohl was schief gelaufen :(','error',1);
  }
}
function manageLastSeen(type = 'add', handle = false, id = false, img = false){
  if(lastSeenShow){
    var lastSeen 		= localStorage.getItem('__t_lsp');
    var lastSeenObj 	= (!lastSeen) ? {} : JSON.parse(lastSeen);
    var lastSeen_now  = Math.round(new Date().getTime());
    //console.log(handle,id,lastSeen,lastSeenObj);
    if(type == 'add'){
      var productVar 	  = firstAvailableVariants[handle];
      var productScale 	  = (productVar) ? productVar.scale : "contain";
      var productHash     = getUniqueID(handle);
      var randomKey       = getRandomInt(0, 7);
      var rotateArr       = ["-6deg","-5deg","-4deg","-3deg","3deg","4deg","5deg","6deg"];
      var productRotate   = rotateArr[randomKey] ?? "-6deg";
      if(lastSeenObj.hasOwnProperty(handle)){
        var clicks = (lastSeenObj[handle].hasOwnProperty('clicks')) ? parseInt(lastSeenObj[handle].clicks) : 0;
      }else{ var clicks = 0; }
      lastSeenObj[handle] = {
        "hash": productHash, 
        "variant": parseInt(id), 
        "img": {
          "url": img, 
          "rotate": productRotate,
          "scale": productScale
        },
        "stamp": lastSeen_now, 
        "clicks": (clicks + 1)
      };
      if(currentProductObj){
        var variantObj = getObjFromArrayByValueOfKey(currentProductObj.variants, 'id', parseInt(id));
        if(variantObj){ lastSeenObj[handle]['data'] = variantObj; }
      }
      localStorage.setItem('__t_lsp',JSON.stringify(lastSeenObj));
    }else if(type == 'list'){
      var lastSeenArr = [];
      $(".dgs-lastseen").removeAttr("dgs-hidden-important");
      for (const [key, value] of Object.entries(lastSeenObj)) {
        var lastSeenItem = value;
        lastSeenItem['handle'] = key;
        lastSeenArr.push(lastSeenItem);
      }
      lastSeenArr.sort((a, b) => a.stamp < b.stamp ? -1 : 1);
      lastSeenArr.reverse();
      if(lastSeenNoCart){
        var cartIDs = (cartJSON.items).map(function(item){ return item.id; });
        var lastSeenDiff = lastSeenArr.filter(e => !cartIDs.includes(e.variant));
      }else{ var lastSeenDiff = lastSeenArr; }
      if(currentProduct){
        var lastSeenDiff = lastSeenDiff.filter(e => e.handle != currentProduct.product);
      }
      //console.log(lastSeenArr,cartIDs,lastSeenDiff);
      return lastSeenDiff;
    }
  }
}
function generateCoolshippingModal(){
  var source 		= document.getElementById("dgs-tpl-cart-coolshipping").innerHTML; 
  var template 		= Handlebars.compile(source);
  var tpl_headline  = "Gekühlter Versand ❄️❄️❄️";
  var tpl_message   = "<p>Damit deine Produkte in optimaler Qualität bei dir ankommen, versenden wir deine Bestellung mit unserem <b>Anti-Schmelz-Service</b>.</p><p>So stellen wir sicher, dass Produkte, die einen <b>gekühlten Versand benötigen</b>, auch gekühlt bei dir ankommen.</p><p>Deine Produkte befinden sich weiterhin innerhalb eines Paketes und die <b>Gebühr i.H.v. 3,99€ fällt nur einmalig</b> an.</p>";
  var tpl_button    = "ALLES KLAR | VERSTANDEN";
  var context 		= {title:tpl_headline, desc:tpl_message, btn:tpl_button};
  var $render 	= template(context);
  $render 		= $render.replaceAll(/\n|\r/g, "").replaceAll(/\s{2,}/g, ' ');
  openModal('Handlebars',$render,"cart-coolshipping-modal",0,0);
}
function errorNoti(text = false){
  var text = text ?? 'Da ist wohl was schief gelaufen :(';
  openNotification(text,"error",1);
}